import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatVariluxGoalsResponse } from "../../utils/varilux-goals-utils";

export function useVariluxGoalsById() {
	const [variluxGoals, setVariluxGoals] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchVariluxGoalsById(segmentationId, variluxGoalsId) {
		if (!segmentationId) {
			setVariluxGoals(null);
			setError("Não foi possível identificar o tamanho do cliente.");

			return {
				ok: false,
				reason: "validation",
				error: "Não foi possível identificar o tamanho do cliente."
			};
		}

		if (!variluxGoalsId) {
			setVariluxGoals(null);
			setError("Não foi possível identificar a meta Varilux.");

			return {
				ok: false,
				reason: "validation",
				error: "Não foi possível identificar a meta Varilux."
			};
		}

		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				}
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}/varilux/${encodeURIComponent(variluxGoalsId)}`,
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar os dados da meta Varilux."
				);
			}

			const data = await response.json();

			const variluxGoalsData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

			const formattedVariluxGoals = formatVariluxGoalsResponse(variluxGoalsData);

			setVariluxGoals(formattedVariluxGoals);

			return {
				ok: true,
				variluxGoals: formattedVariluxGoals
			};
		} catch (requestError) {
			setVariluxGoals(null);
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		variluxGoals,
		loading,
		error,
		fetchVariluxGoalsById
	};
}